module.exports = __webpack_public_path__ + "static/media/logo-inmaculada.f6190d2b.jpg";